import React from 'react';
import {NavLink, useParams} from "react-router-dom";
import {HomeOutlined} from "@ant-design/icons";
import Vegetatsiya from "./veg/Index";
import Novegetatsiya from "./noveg/Index";

function Index(props) {
    const params = useParams()
    const season = localStorage.getItem('sfr-hm-season')
    return (
        <div className="row">
            <div className="col-12">
                <div className="xisobotlar-menu bg-white" style={{margin:"2px -20px"}}>
                    <ul>
                        <li><NavLink to="/sfr/gidromodul"><HomeOutlined/></NavLink></li>
                        <li><NavLink to="/sfr/gidromodul/new">Ekin tanlash</NavLink></li>
                        <li><NavLink to="/sfr/gidromodul/new/insert">Ma'lumot kiritish</NavLink></li>
                        <li><NavLink to="/sfr/gidromodul/new/reports">Xisobotlar</NavLink></li>
                    </ul>
                    <ul>
                        <li><NavLink to="/sfr/gidromodul/new/limits" className={params['*'] == ''?'activ':''}>Limit kiritish</NavLink></li>
                        <li><NavLink to="/sfr/gidromodul/new/limits/table1" className={params['*'] == 'table1'?'activ':''}>Jadval №1</NavLink></li>
                        <li><NavLink to="/sfr/gidromodul/new/limits/table2" className={params['*'] == 'table2'?'activ':''}>Jadval №2</NavLink></li>
                        <li><NavLink to="/sfr/gidromodul/new/limits/table3" className={params['*'] == 'table3'?'activ':''}>Jadval №3</NavLink></li>
                        <li><NavLink to="/sfr/gidromodul/new/limits/table4" className={params['*'] == 'table4'?'activ':''}>Jadval №4</NavLink></li>
                    </ul>
                </div>
            </div>
            <div className="col-12" id="tblData">
                {
                    season == 'veg'?<Vegetatsiya/>:<Novegetatsiya/>
                }
            </div>
        </div>
    );
}

export default Index;